import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirteen',
  templateUrl: './home-thirteen.component.html',
  styleUrls: ['./home-thirteen.component.scss']
})
export class HomeThirteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
